/**
 * This function returns the most appropriate currency for a given country code.
 * It is used to set the currency by user preference.
 *
 * NOTE: this is currently used only in the ROW store, for visualization preference of the currency for the user.
 *
 * @param countryCode - The ISO code of the country.
 * @returns - The most appropriate currency for the country.
 */
export const getCurrencyByCountryCode = (
  countryCode: string,
): 'CAD' | 'CHF' | 'NOK' | 'RUB' | 'AUD' | 'EUR' => {
  switch (countryCode) {
    case 'CA': {
      return 'CAD'
    }
    case 'CH': {
      return 'CHF'
    }
    case 'NO': {
      return 'NOK'
    }
    case 'RU': {
      return 'RUB'
    }
    case 'AU': {
      return 'AUD'
    }
    default: {
      return 'EUR'
    }
  }
}
